import { getFlowOriginId, getFlowDestId, isFlowInSelection, getFlowMagnitude } from './commonGetters';

export const getFlowMagnitudeExtent = (flows, selectedLocationsSet) => {
    let rv = null;
    for (const flow of flows) {
        if (
            getFlowOriginId(flow) !== getFlowDestId(flow) &&
            isFlowInSelection(flow, selectedLocationsSet)
        ) {
            const count = getFlowMagnitude(flow);
            if (rv === null) {
                rv = [ count, count ];
            } else {
                if (count < rv[0]) {
                    rv[0] = count;
                }
                if (count > rv[1]) {
                    rv[1] = count;
                }
            }
        }
    }
    return rv;
};
